import React, { FC, useMemo, useState } from 'react';
import { ISwipeDialogProps } from '../models';
import { useViewPortMobileKeyboard } from '@src/hooks/useViewPortMobileKeyboard';
import { SwipeDialog } from '@src/molecules/SwipeDialog';
import { PAGE_FILTER_TYPE_COMPONENTS } from './config';
import { classnames } from '@src/utils/classnames';
import { Unit } from '@src/core/Unit';

import styles from './FiltersSwipeDialog.module.scss';
import { FiltersSwipeDialogContext } from './context';

interface IFiltersSwipeDialogProps extends ISwipeDialogProps {
  /** Имя фильтра, позваляет открыть подробную страницу настройки фильтра если она подразумевается */
  filterName?: string;
}

/** Чаще всего это будет использоваться как базовый компонент отображения мобильных фильтров с функциями свайпа */
export const FiltersSwipeDialog: FC<IFiltersSwipeDialogProps> = ({ filterName: filterNameProps, ...props }) => {
  const height = useViewPortMobileKeyboard({ defaultElementHeight: '100vh', forceSetHeight: true });

  const [filterName, setFilterName] = useState<string | null>(filterNameProps || null);

  const filter = useMemo(
    () => (filterName ? props.controller.getScheme().get(filterName) : undefined),
    [filterName, props.controller],
  );

  const value = useMemo(() => ({ height }), [height]);

  const { Component, isWhiteBg } = useMemo(() => {
    if (filter && PAGE_FILTER_TYPE_COMPONENTS[filter?.type]) {
      return { Component: PAGE_FILTER_TYPE_COMPONENTS[filter.type]!, isWhiteBg: true };
    }

    return { Component: PAGE_FILTER_TYPE_COMPONENTS.default, isWhiteBg: false };
  }, [filter]);

  const itemClasses = classnames(styles.slideItem, {
    [styles.slideItemWhite]: isWhiteBg,
  });

  return (
    <Unit id="FilterSwipeDialog">
      <SwipeDialog
        style={{ height }}
        onClose={props.onClose}
        className={styles.swipe}
        slideClasses={itemClasses}
        backdropStyle={{ height }}
      >
        <FiltersSwipeDialogContext.Provider value={value}>
          <Component
            {...props}
            setActiveFilterName={setFilterName}
            filter={
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              filter!
            }
          />
        </FiltersSwipeDialogContext.Provider>
      </SwipeDialog>
    </Unit>
  );
};
